// extracted by mini-css-extract-plugin
export default {"root":"Questionnaires_root__PB3c0","tabs":"Questionnaires_tabs__khJrd","iqTitle":"Questionnaires_iqTitle__11IZ0"};